import type { Editor } from '@tiptap/core';
import type { Node } from '@tiptap/pm/model';

import type { IContent, IEventEmitter } from './../ricos-types';

import EventEmitter from './lib/EventEmitter';
import type { ContentServices } from './types';

export class Content<T = Node[]> extends EventEmitter implements IContent<T>, IEventEmitter {
  static EVENTS = {
    contentChangeEvent: 'contentChange',
  };

  editor: any;

  private constructor(private content: T, private services: ContentServices) {
    super();
  }

  resolve(contentResolver: $TSFixMe) {
    return contentResolver.resolve(this.content, this.services, this.editor);
  }

  //TODO: should be removed
  forceUpdate() {
    this.update(this.content, this.editor);
  }

  update(content: T, editor?: Editor) {
    this.content = content;
    this.editor = editor;
    this.emit(Content.EVENTS.contentChangeEvent);
  }

  get value() {
    return this.content;
  }

  isEmpty() {
    return !!this.content;
  }

  static create<T>(content: T, services: ContentServices) {
    return new Content(content, services);
  }
}
